import { render, staticRenderFns } from "./SpecialistPlate.vue?vue&type=template&id=4cf42343&scoped=true&"
import script from "./SpecialistPlate.vue?vue&type=script&lang=js&"
export * from "./SpecialistPlate.vue?vue&type=script&lang=js&"
import style0 from "./SpecialistPlate.vue?vue&type=style&index=0&id=4cf42343&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf42343",
  null
  
)

export default component.exports